module.exports = __webpack_public_path__ + "static/media/toolgauge_homepage.b49d573d.png";